import { render } from "./Tables.vue?vue&type=template&id=85887250&scoped=true"
import script from "./Tables.vue?vue&type=script&lang=js"
export * from "./Tables.vue?vue&type=script&lang=js"

import "./Tables.vue?vue&type=style&index=0&id=85887250&lang=scss&scoped=true"

import exportComponent from "/app/tmp/360pt/V3/v2026.6.r0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-85887250"]])

export default __exports__